import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import CamperService from '../../api/services/CamperService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';

const SubscriptionCamper = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_CAMPER_IMAGE_URL;
    const [camper, setCamper] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const params = useParams()
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = camper.slice(firstIndex, lastIndex);
    const npage = Math.ceil(camper.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getCamper();
        }
        else {
            navigate('/')
        }
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getCamper = async () => {
        try {

            let camper = await CamperService.index().json();

            var fetchdata = camper.data.filter((element) => { return element.camper_type_id === 2 })
            setCamper(fetchdata);
            setisloading(false)
        } catch (error) {
            console.log(error);
        }
    };

    const deleteCamper = async (id) => {

        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                let responseData = await CamperService.destroy(id).json()
                if (responseData.status === true) {
                    getCamper();
                }
                swal("Your Camper has been deleted successfully!", {
                    icon: "success",
                });
            }
        }).catch(() => {
            swal("Your Camper is safe!");
        });
    }
    const updateCamperstatus = async (id) => {
        await CamperService.updateCamperstatus(id).json()
        getCamper();
    }
    const updateCalendarStatus = async (id) => {
        swal({
            title: "Are you sure?",
            text: "You want to update status!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                let responseData = await CamperService.updateCamperCalendar(id).json()
                if (responseData.status === true) {
                    getCamper();
                }
                swal("Your Camper Updated successfully!", {
                    icon: "success",
                });
            }
        }).catch(() => {
            swal("Your Camper is safe!");
        });

    }
    return (
        <>
            <MainPagetitle mainTitle="Camper" pageTitle={'Camper'} parentTitle={'Home'} />

            <div className="container-fluid">

                <div className="row">

                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Camper</h4>
                                        <div>
                                            <Link to={`/admin/add_camper_subscription`} className="btn btn-primary btn-sm ms-1">+ Add Camper</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Camper Title</th>
                                                    <th>Image</th>
                                                    <th>Camper Type</th>
                                                    {/* <th>Licence Plate</th> */}
                                                    <th>Status</th>
                                                    <th>Calendar</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map(
                                                        (item, index) => {
                                                            return (

                                                                <>
                                                                    <tr key={index}>
                                                                        <td><span>{index + 1}</span></td>
                                                                        <td>
                                                                            <div className="products">

                                                                                <h6>{item.title}</h6>

                                                                            </div>
                                                                        </td>

                                                                        <td>
                                                                            <img className="img-drop-area" height={item.image ? 50 : 0} width={item.image ? 50 : 0} src={item.image ? imageUrl + item.image : "camper"} alt='camper' />
                                                                        </td>
                                                                        <td>
                                                                            <h6>{item.camper_type}</h6>
                                                                        </td>
                                                                        {/* <td>
                                                                            <h6>{item.license_plate}</h6>
                                                                        </td> */}
                                                                        <td>
                                                                            <h6>{item.status == 1 ? <span className='btn btn-success'>Active</span> : <span className='btn btn-danger'>In Active</span>}</h6>
                                                                            <Link onClick={() => { updateCamperstatus(item.id) }}
                                                                            >
                                                                                Change?
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <h6>{item.is_calendar == 1 ? <span className='btn btn-success'>On</span> : <span className='btn btn-danger'>Off</span>}</h6>
                                                                            <Link onClick={() => { updateCalendarStatus(item.id) }}
                                                                            >
                                                                                Change?
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex">
                                                                                <Link
                                                                                    to={`/admin/edit_subscription/${item.id}`}
                                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                                >
                                                                                    <i className="fas fa-pencil-alt"></i>
                                                                                </Link>
                                                                                <Link className="btn btn-danger shadow btn-xs sharp" onClick={() => { deleteCamper(item.id) }}
                                                                                >
                                                                                    <i className="fa fa-trash"></i>
                                                                                </Link>
                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                </>
                                                            )


                                                        })
                                                }
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {camper.length < lastIndex ? camper.length : lastIndex}
                                                {" "}of {camper.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default SubscriptionCamper;